import React from 'react'
import { Loader2, Check } from 'lucide-react'
import {
  SaveStatusIndicator,
  SpinningLoader,
  SaveStatusText,
} from '../../styles/MindMapHeaderStyles'

interface SaveStatusDisplayProps {
  isSaving: boolean
  showIndicator: boolean
}

export const SaveStatusDisplay: React.FC<SaveStatusDisplayProps> = ({
  isSaving,
  showIndicator,
}) => {
  if (!showIndicator) return null

  return (
    <SaveStatusIndicator $isSaving={isSaving}>
      {isSaving ? (
        <>
          <SpinningLoader>
            <Loader2 size={14} />
          </SpinningLoader>
          <SaveStatusText>Saving...</SaveStatusText>
        </>
      ) : (
        <>
          <Check size={14} strokeWidth={2.5} />
          <SaveStatusText>Saved</SaveStatusText>
        </>
      )}
    </SaveStatusIndicator>
  )
}
